<template>
  <div class="modal-form-container" style="max-width: 700px">
    <div ref="modalContent" class="w-full h-full">
      <header class="border-b modal-form-container-header border-line">
        <h1 class="flex items-center modal-form-container-header-title">3D모델 분석 상세 설명</h1>
        <div>
          <button @click="onClose"><i class="fi fi-rr-cross"></i></button>
        </div>
      </header>

      <div class="modal-form-container-content">
        <inst-desc1 v-if="'loadFile' === cModalData"></inst-desc1>
        <inst-desc2 v-if="'normalSize' === cModalData"></inst-desc2>
        <inst-desc3 v-if="'overVolume' === cModalData"></inst-desc3>
        <inst-desc4 v-if="'checkModel' === cModalData"></inst-desc4>
        <inst-desc5 v-if="'waterproof' === cModalData"></inst-desc5>
        <inst-desc6 v-if="'multiBody' === cModalData"></inst-desc6>
        <inst-desc7 v-if="'buildSize' === cModalData"></inst-desc7>
        <inst-desc8 v-if="'thickness' === cModalData"></inst-desc8>
        <inst-desc9 v-if="'gap' === cModalData"></inst-desc9>
        <inst-desc10 v-if="'hollow' === cModalData"></inst-desc10>
      </div>
    </div>
  </div>
</template>

<script setup>
import InstDesc1 from "./instructions/InstDesc1.vue";
import InstDesc2 from "./instructions/InstDesc2.vue";
import InstDesc3 from "./instructions/InstDesc3.vue";
import InstDesc4 from "./instructions/InstDesc4.vue";
import InstDesc5 from "./instructions/InstDesc5.vue";
import InstDesc6 from "./instructions/InstDesc6.vue";
import InstDesc7 from "./instructions/InstDesc7.vue";
import InstDesc8 from "./instructions/InstDesc8.vue";
import InstDesc9 from "./instructions/InstDesc9.vue";
import InstDesc10 from "./instructions/InstDesc10.vue";
import {storeToRefs} from "pinia";
import {CommonStore} from "../../store/common-store";
const {cModalData} = storeToRefs(CommonStore());

const onClose = () => {
  CommonStore().closeModal();
};
</script>
